import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Surface } from '../../UI/Surface';

export const Root = styled(Surface)(({ theme }) => {
  const { space } = theme.palette.tokens;
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: space[4],
    padding: `${space[4]}px ${space[5]}px`,
    margin: `${space[4]}px 0 ${space[5]}px`,
  };
});

export const Head = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.palette.tokens.space[3],
  flexWrap: 'wrap',
}));

export const HeadTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.palette.tokens.space[2],
  ...theme.typography.subtitle2,
  fontWeight: theme.palette.tokens.font.weightMedium,
  color: theme.palette.text.primary,
  '& > span': { fontSize: '20px', color: theme.palette.text.secondary },
}));

export const Actions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.palette.tokens.space[2],
  flexWrap: 'wrap',
}));

export const Items = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
  gap: `${theme.palette.tokens.space[3]}px ${theme.palette.tokens.space[6]}px`,
}));

export const Item = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  minWidth: 0,
}));

export const ItemLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.secondary,
  whiteSpace: 'nowrap',
}));

export const ItemValue = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'mono' && prop !== 'muted',
})<{ mono?: boolean; muted?: boolean }>(({ theme, mono, muted }) => ({
  ...theme.typography.body1,
  fontWeight: theme.palette.tokens.font.weightMedium,
  color: muted ? theme.palette.text.disabled : theme.palette.text.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  ...(mono && {
    fontVariantNumeric: 'tabular-nums lining-nums',
    fontFeatureSettings: '"tnum" 1, "lnum" 1',
  }),
}));

export const ItemHint = styled('span')(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.secondary,
  marginLeft: '6px',
  fontWeight: theme.palette.tokens.font.weightRegular,
}));
